/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";

import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import ValidatorSelect from "../../../Validator/ValidatorSelect";
import ValidatorNumberField from "../../../Validator/ValidatorNumberField";
import { processCostSupportStyle } from "../../processCostSupportStyle";
import { UseForm } from "../../../../types/UseForm";
import { OtherAssets } from "../../../../types/ProcessCostSupport";

type ValuableProps = {
  path: string;
  otherAsset: OtherAssets;
  handleChange: UseForm["handleChange"];
};

const Valuable = ({ path, otherAsset, handleChange }: ValuableProps) => {
  return (
    <>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Geben Sie hier bitte weitere Details zu dem Vermögenswert an
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <TextField
          fullWidth={true}
          name={path + ".name"}
          label="Bezeichung"
          margin="normal"
          value={otherAsset.name}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <ValidatorSelect
          label={"Allein- oder Miteigentum"}
          fullWidth
          value={otherAsset.ownership}
          onChange={handleChange}
          name={path + ".ownership"}
          inputProps={{
            name: path + ".ownership",
          }}
          MenuProps={{
            slotProps: {
              paper: {
                sx: { maxHeight: 200 },
              },
            },
          }}
        >
          <MenuItem value={"Alleineigentum"}>Alleineigentum</MenuItem>
          <MenuItem value={"Miteigentum"}>Miteigentum</MenuItem>
        </ValidatorSelect>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          fullWidth={true}
          name={path + ".value"}
          label="Verkehrswert"
          margin="normal"
          value={otherAsset.value}
          helperText={
            "Gemeint ist dabei der Preis, der jetzt bei einem Verkauf erzielt werden kann. Geben Sie hier ruhig eine Schätzung ab."
          }
          onChange={handleChange}
        />
      </Grid>
    </>
  );
};

export default Valuable;
